const DEBUGGING_ENABLED = true;	// If true, console log the evnets for GTM
let variationData = null;

/**
 * Returns the currency - currently hard coded
 * @returns {string}
 */
function getCurrency() {
	return 'AUD';
}

const defaultProductData = {
	item_name: '',
	maker: '',
	item_category: '',
	item_category2: '',
};

/**
 * Simple products - view item event
 * @constructor
 */
export function ViewItemEventSimple() {
	let parentData = defaultProductData;

	// Get the product data if possible
	const item = document.querySelector('.product-body');
	if( item )
	{
		const productData = item.getAttribute('product_data');
		if( productData != null ) {
			parentData = JSON.parse(productData);
		}
	}
	else {
		// Can't get data so no point
		return;
	}

	if( 'simple' != parentData.product_type )
	{
		// Only run if this is ia simple product, variable use the below function
		return;
	}

	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	let colour1 = null;
	let colour2 = null;

	window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

	const urlParams = new URLSearchParams(window.location.search);

	const itemIndex = urlParams.get('item_index');
	const itemListId = urlParams.get('list_id');
	const itemListName = urlParams.get('list_name');

	// Push the data
	const data = {
		event: 'custom.ecommerce.view_item',
		action: 'view_item',
		ecommerce: {
			item_id: parentData.item_id,
			item_name: parentData.item_name,
			item_colour: colour1,
			item_colour2: colour2,
			item_category: parentData.item_category,
			item_category2: parentData.item_category2,
			maker: parentData.maker,
			price: parentData.display_price,
			quantity: 1,
			index: itemIndex,
			item_list_id: itemListId,
			item_list_name: itemListName,
		},
	};

	if(DEBUGGING_ENABLED)
	{
		console.log('Pushing GTM Event', data);
	}

	window.dataLayer.push(data);
}

/**
 * Custom Tracking Events
 */
export function ViewItemEvent(variation) {
	let parentData = defaultProductData;

	// Get the product data if possible
	const item = document.querySelector('.product-body');
	if( item )
	{
		const productData = item.getAttribute('product_data');
		if( productData != null ) {
			parentData = JSON.parse(productData);
		}
	}

	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	let colour1 = null;
	let colour2 = null;
	const attributes = variation.attributes;
	if( attributes )
	{
		let counter = 0;
		for (const key in attributes) {
			counter++;
			if(counter == 1 )
			{
				colour1 = attributes[key];
			}
			else
			{
				colour2 = attributes[key];
			}
		}
	}

	window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

	const urlParams = new URLSearchParams(window.location.search);

	const itemIndex = urlParams.get('item_index');
	const itemListId = urlParams.get('list_id');
	const itemListName = urlParams.get('list_name');

	// Push the data
	const data = {
		event: 'custom.ecommerce.view_item',
		action: 'view_item',
		ecommerce: {
			item_id: variation.variation_id,
			item_name: parentData.item_name,
			item_colour: colour1,
			item_colour2: colour2,
			item_category: parentData.item_category,
			item_category2: parentData.item_category2,
			maker: parentData.maker,
			price: variation.display_price,
			quantity: 1,
			index: itemIndex,
			item_list_id: itemListId,
			item_list_name: itemListName,
		},
	};

	if(DEBUGGING_ENABLED)
	{
		console.log('Pushing GTM Event', data);
	}

	window.dataLayer.push(data);
}

function SelectItemEvent(e) {
	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	// Clear the previous ecommerce object.
	window.dataLayer.push({ ecommerce: null });

	let items = [];
	const item = e.currentTarget;
	const productData = item.getAttribute('product_data');
	if( productData != null )
	{
		const itemIndex = item.getAttribute('data-item-index');
		const productDataJson = JSON.parse(productData);
		const itemData = {
			item_id: productDataJson.item_id,
			item_name: productDataJson.item_name,
			item_colour: productDataJson.item_colour,
			item_colour2: productDataJson.item_colour2,
			item_category: productDataJson.item_category,
			item_category2: productDataJson.item_category2,
			maker: productDataJson.maker,
			index: itemIndex,
			price: productDataJson.price,
			quantity: 1,
		};
		items.push(itemData);
	}

	const list_obj = document.querySelector('.archive-header .text-stack__heading');
	let list_name = '';
	let list_id = '';
	if( list_obj )
	{
		list_name = list_obj.innerHTML;
		list_id = list_name.toLowerCase().replace(' ', '_');
	}

	const data = {
		event: 'custom.ecommerce.select_item',
		action: 'select_item',
		ecommerce: {
			items_list_id: list_id,
			item_list_name: list_name,
			items: items,
		},
	};

	if (DEBUGGING_ENABLED)
	{
		console.log('Sending GTM event', data);
	}

	// Push the data
	window.dataLayer.push(data);
}

function ViewItemListEvent() {
	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	// Clear the previous ecommerce object.
	window.dataLayer.push({ ecommerce: null });
	let items = [];
	let wrapper = document.querySelector('.product-archive__body');
	if( !wrapper )
	{
		wrapper = document.querySelector('.page-builder');
	}
	const dataItems = wrapper.querySelectorAll('.card');

	/**
	 * List data - used to add to urls
	 */
	let list_obj = document.querySelector('.archive-header .text-stack__heading');
	if( null == list_obj )
	{
		list_obj = document.querySelector('h1.text-stack__heading');
	}
	let list_name = '';
	let list_id = '';
	if( list_obj )
	{
		list_name = list_obj.innerHTML;
		list_id = list_name.toLowerCase().replace(' ', '_');
	}

	if( dataItems && dataItems.length > 0 )
	{
		dataItems.forEach((item, i) => {
			const productData = item.getAttribute('product_data');
			if( productData != null && productData.length > 0)
			{
				const itemIndex = i + 1;
				const productDataJson = JSON.parse(productData);
				const itemData = {
					item_id: productDataJson.item_id,
					item_name: productDataJson.item_name,
					item_colour: productDataJson.item_colour,
					item_colour2: productDataJson.item_colour2,
					item_category: productDataJson.item_category,
					item_category2: productDataJson.item_category2,
					maker: productDataJson.maker,
					index: itemIndex,
					price: productDataJson.price,
					quantity: 1,
				};
				items.push(itemData);

				// Attach an event to each as well
				item.addEventListener('click', function (e) {
					SelectItemEvent(e);
				});

				// Add the index to it
				item.setAttribute('data-item-index', itemIndex);

				let linkObj = item.querySelector('a.card__link-wrapper');
				if( linkObj )
				{
					let url = linkObj.getAttribute('href');
					url += `?list_id=${list_id}&list_name=${list_name}&item_index=${itemIndex}`;
					linkObj.setAttribute('href', url);
				}
			}
		});
	}

	const data = {
		event: 'custom.ecommerce.view_item_list',
		action: 'view_item_list',
		ecommerce: {
			items_list_id: list_id,
			item_list_name: list_name,
			items: items,
		},
	};

	if (DEBUGGING_ENABLED)
	{
		console.log('Sending GTM event', data);
	}

	// Push the data
	window.dataLayer.push(data);
}

export function SetEnquireButtonData(variation)
{
	variationData = variation;
}

export function SingleProductEnquiryStart(variation) {
	// eslint-disable-next-line no-undef
	let parentData = defaultProductData;

	const item = document.querySelector('.product-body');
	if( item )
	{
		const productData = item.getAttribute('product_data');
		if( productData != null ) {
			parentData = JSON.parse(productData);
		}
	}

	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	let colour1 = null;
	let colour2 = null;
	const attributes = variation.attributes;
	if( attributes )
	{
		let counter = 0;
		for (const key in attributes) {
			counter++;
			if(counter == 1 )
			{
				colour1 = attributes[key];
			}
			else
			{
				colour2 = attributes[key];
			}
		}
	}

	// Push the data
	const data = {
		event: 'custom.enquiry.start',
		action: 'enquiry_start',
		item_id: variation.variation_id,
		item_name: parentData.item_name,
		item_colour: colour1,
		item_colour2: colour2,
		maker: parentData.maker,
		item_category: parentData.item_category,
		item_category2: parentData.item_category2,
		price: variation.display_price,
	};

	if(DEBUGGING_ENABLED)
	{
		console.log('Pushing GTM Event', data);
	}

	window.dataLayer.push(data);
}

function SetupEnquireEventSimple() {
	const enquireButton = document.querySelector('.button.enquire-button');
	const enquireButtonMobile = document.querySelector('.button.enquire-button-mobile');

	let parentData = defaultProductData;

	// Get the product data if possible
	const item = document.querySelector('.product-body');
	if( item )
	{
		const productData = item.getAttribute('product_data');
		if( productData != null ) {
			parentData = JSON.parse(productData);
		}
	}
	else {
		// Can't get data so no point
		return;
	}

	if( 'simple' != parentData.product_type )
	{
		// Only run if this is ia simple product, variable use the below function
		return;
	}

	if (enquireButton) {
		enquireButton.addEventListener('click', function () {
			parentData.variation_id = parentData.item_id;
			SingleProductEnquiryStart(parentData);
		});
	}

	console.log('mobile enquire', enquireButtonMobile);
	if (enquireButtonMobile) {
		enquireButtonMobile.addEventListener('click', function () {
			parentData.variation_id = parentData.item_id;
			SingleProductEnquiryStart(parentData);
		});
	}
}

export function EnquirySelectedSetup() {
	let parentData = defaultProductData;

	// Get the product data if possible
	const item = document.querySelector('.product-body');

	if ( !item ) {
		return;
	}

	const productData = item.getAttribute('product_data');
	if( productData != null ) {
		parentData = JSON.parse(productData);
	}

	let variation = parentData;
	if( 'variable' == parentData.product_type ) {
		variation = variationData;
	}

	EnquirySelectedEvent(variation);
}

export function AddToCartEvent() {
	let variation = variationData;

	// eslint-disable-next-line no-undef
	let parentData = defaultProductData;

	const item = document.querySelector('.product-body');
	if( item )
	{
		const productData = item.getAttribute('product_data');
		if( productData != null ) {
			parentData = JSON.parse(productData);
		}
	}

	if( !variationData )
	{
		variation = parentData;
	}

	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	// Clear the previous ecommerce object.
	window.dataLayer.push({ ecommerce: null });

	// Get the list params
	const urlParams = new URLSearchParams(window.location.search);

	const itemIndex = urlParams.get('item_index');
	const itemListId = urlParams.get('list_id');
	const itemListName = urlParams.get('list_name');

	// Get the attributes
	let colour1 = null;
	let colour2 = null;
	const attributes = variation.attributes;
	if( attributes )
	{
		let counter = 0;
		for (const key in attributes) {
			counter++;
			if(counter == 1 )
			{
				colour1 = attributes[key];
			}
			else
			{
				colour2 = attributes[key];
			}
		}
	}

	// Push the data
	const data = {
		event: 'custom.ecommerce.add_to_cart',
		action: 'add_to_cart',
		ecommerce: {
			item_list_id: itemListId,
			item_list_name: itemListName,
			items: [
				{
					item_id: variation.variation_id,
					item_name: parentData.item_name,
					item_colour: colour1,
					item_colour2: colour2,
					item_category: parentData.item_category,
					item_category2: parentData.item_category2,
					maker: parentData.maker,
					price: variation.display_price,
					quantity: 1,
					index: itemIndex,
				},
			],
		},
	};

	if(DEBUGGING_ENABLED)
	{
		console.log('Pushing GTM Event', data);
	}

	window.dataLayer.push(data);
}

export function EnquirySelectedEvent(variation) {
	let parentData = defaultProductData;

	// Get the product data if possible
	const item = document.querySelector('.product-body');
	if( item )
	{
		const productData = item.getAttribute('product_data');
		if( productData != null ) {
			parentData = JSON.parse(productData);
		}
	}

	// Set the datalayer
	window.dataLayer = window.dataLayer || [];

	let colour1 = null;
	let colour2 = null;
	const attributes = variation.attributes;
	if( attributes )
	{
		let counter = 0;
		for (const key in attributes) {
			counter++;
			if(counter == 1 )
			{
				colour1 = attributes[key];
			}
			else
			{
				colour2 = attributes[key];
			}
		}
	}

	// Push the data
	const data = {
		event: 'custom.enquiry.selected',
		action: 'enquiry_items_selected',
		item_id: variation.variation_id,
		item_name: parentData.item_name,
		item_colour: colour1,
		item_colour2: colour2,
		item_category: parentData.item_category,
		item_category2: parentData.item_category2,
		maker: parentData.maker,
		price: variation.display_price,
		quantity: 1,
	};

	if(DEBUGGING_ENABLED)
	{
		console.log('Pushing GTM Event', data);
	}

	window.dataLayer.push(data);
}

export const initTracking = () => {
	// Custom tracking
	window.dataLayer = window.dataLayer || [];
	const classList = document.body.classList
	const logged_in = classList.contains('logged_in');
	const content_type = (classList.contains('designer-template-default') || classList.contains('designers-makers')) ? 'maker'
		: classList.contains('product-template-default') ? 'product'
			: (classList.contains('collections') || classList.contains('single-collection')) ? 'collection'
				: 'content'

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);

	// Add to cart for mobile tracking
	const addToCartMobileButtons = document.querySelectorAll('.single_add_to_cart_button');

	if(addToCartMobileButtons) {
		Array.from(addToCartMobileButtons).forEach(addToCartMobileButton => {
			addToCartMobileButton.addEventListener('click', function() {
				AddToCartEvent();
			});
		});
	}

	// Initial dataLayer
	window.dataLayer.push({
		content_type,
		logged_in,
	});

	if(classList.contains('single-product') ) {
		// Single product tracking for simple products
		ViewItemEventSimple();
		SetupEnquireEventSimple();
	}

	if(classList.contains('post-type-archive-product')
		|| classList.contains('tax-product_cat')
		|| classList.contains('tax-room_category')
		|| classList.contains('single-collection')
	) {
		ViewItemListEvent();
	}

	if(classList.contains('search-results')){
		const children = document.querySelector('.product-listing__grid').children

		// View Search Results
		window.dataLayer.push({
			event: 'custom.search.view',
			action: 'view_search_results',
			// type: '<type>', (Looks like there's only one search?)
			search_term: urlParams.get('s'),
			search_results: children.length,
		});

		const searchLinks = document.querySelectorAll('.product-listing__grid a')
		// Click Search Result
		searchLinks.forEach((link, i) => {
			link.addEventListener('click', () => {
				window.dataLayer.push({
					event: 'custom.search.click',
					action: 'click_search_results',
					// type: '<type>',
					search_term: urlParams.get('s'),
					search_results: children.length,
					position: i,
				});
			})
		})
	}

	// Forms
	const forms = [
		{
			title: 'log in',
			node: document.querySelector('.woocommerce-form-login'),
		},
		{
			title: 'create an account',
			node: document.querySelector('.woocommerce-form-register'),
		},
		{
			title: 'subscribe',
			node: document.querySelector('#subForm'),
		},
		{
			title: 'email us',
			node: document.querySelector('#gform_3'),
		},
	]

	// Form Start
	forms.forEach((form) => {
		if(!form.node) return
		const firstInput = form.node.querySelector('input, select')
		firstInput.addEventListener('focus', () => {
			window.dataLayer.push({
				event: 'custom.form.start',
				action: 'form_start',
				name: form.title,
			});
		})
	})

	// Field Complete
	forms.forEach((form) => {
		if(!form.node) return
		const inputs = form.node.querySelectorAll('input, select')
		inputs.forEach((input) => {
			input.addEventListener('blur', () => {
				window.dataLayer.push({
					event: 'custom.form.field.complete',
					action: 'form_field_complete',
					name: form.title,
					type: input.labels[0].textContent.trim(),
					txt_value: input.type !== 'text' && !input.value.includes('@')  ? input.value : undefined,
				});
			})
		})
	})

	// Form Error
	const errorWrap = document.querySelector('.woocommerce-error')
	if (errorWrap && classList.contains('woocommerce-account')){
		const error = errorWrap.querySelector('li').textContent
		window.dataLayer.push({
			event: 'custom.form.error',
			action: 'form_error',
			name: 'account',
			txt_value: error,
		});
	}

	// Sort by

	const sortInputs = document.querySelectorAll('.product-sort__body-lockup input')

	sortInputs.forEach(input => {
		input.addEventListener('click', () => {
			window.dataLayer.push({
				event: 'custom.list.sort',
				action: 'sort_selected',
				name: input.labels[0].textContent.trim(),
			});
		})
	})

	function hash(string) {
		const utf8 = new TextEncoder().encode(string);
		return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
			const hashArray = Array.from(new Uint8Array(hashBuffer));
			const hashHex = hashArray
				.map((bytes) => bytes.toString(16).padStart(2, '0'))
				.join('');
			return hashHex;
		});
	}


	// Form Submit
	forms.forEach(form => {
		if(!form.node) return
		const emailField = form.node.querySelector('input[type="email"]')
		form.node.addEventListener('submit', e => {
			hash(emailField.value).then(hashed => {
				window.dataLayer.push({
					event: 'custom.form.submit',
					action: 'form_submit',
					name: form.title,
					user_id: emailField ? hashed : null,
				});
			});
		})
	})
};



// WEBPACK FOOTER //
// ./scripts/modules/tracking.js